import React, { useMemo } from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import { ColumnStartOrder, ColumnResult, ColumnName, ColumnNoc, ColumnTeamComponents } from "components/common/TableColumns"
import MirsTable from "components/general/table/Table";
import { getIsIndividual, getIsSynchronised } from 'components/sports/div/helper/DivHelpers'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


export function getColumns(current, rsc) {
    return (
        [
            ColumnStartOrder({ disableSort: true }),
            ColumnNoc({ label: "", disableSort: true }),
            ColumnTeamComponents({ disableSort: true }),

            {
                Header: <><Label data='HeaderRound' /> {current}</>,
                id: 'PreviusTeam',
                accessor: 'participant.code',
                className: 'text-start',
                headerClassName: 'text-start',

                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.eventUnitEntries, { eue_pos: [row.currentSplit], eue_code: ['DESC'] })
                    let type = findArray(row?.eventUnitEntries, { eue_pos: [row.currentSplit], eue_code: ['TYPE'] })
                    let dd = findArray(row?.eventUnitEntries, { eue_pos: [row.currentSplit], eue_code: ['DD'] })
                    let valType = (type?.eue_value === 'A')
                        ? <Label data="LabelStraight" />
                        : type.eue_value === 'B' ? <Label data="LabelPike" />
                            : type.eue_value === 'C' ? <Label data="LabelTuck" />
                                : type.eue_value === 'D' ? ''
                                    : ''
                    return (
                        <>  <div><strong><Label data='HeaderDescription' />:</strong> {num?.eue_value}</div>
                            <div><strong><Label data='HeaderPosition' />:</strong> {valType}</div>
                            <div><strong><Label data='HeaderDD' />:</strong> {dd?.eue_value}</div>
                        </>
                    )
                }

            },

            {
                Header: <Label data='HeaderJudgesScore' />,
                id: 'PreviusJudges',
                accessor: 'participant.code',
                className: 'text-center',
                headerClassName: 'text-center',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['DIVE'] })

                    const isIndividual = getIsIndividual(rsc);
                    const isSynchro = getIsSynchronised(rsc);

                    let unsafe = findArray(num?.extensions, { er_code: ['UNSAFE'] })
                    let name1 = findArray(num?.extensions, { ere_pos: ['1'], ere_code: ['JUDGE'] })?.ere_value
                    let name2 = findArray(num?.extensions, { ere_pos: ['2'], ere_code: ['JUDGE'] })?.ere_value
                    let name3 = findArray(num?.extensions, { ere_pos: ['3'], ere_code: ['JUDGE'] })?.ere_value
                    let name4 = findArray(num?.extensions, { ere_pos: ['4'], ere_code: ['JUDGE'] })?.ere_value
                    let name5 = findArray(num?.extensions, { ere_pos: ['5'], ere_code: ['JUDGE'] })?.ere_value
                    let name6 = findArray(num?.extensions, { ere_pos: ['6'], ere_code: ['JUDGE'] })?.ere_value
                    let name7 = findArray(num?.extensions, { ere_pos: ['7'], ere_code: ['JUDGE'] })?.ere_value
                    let name8 = findArray(num?.extensions, { ere_pos: ['8'], ere_code: ['JUDGE'] })?.ere_value
                    let name9 = findArray(num?.extensions, { ere_pos: ['9'], ere_code: ['JUDGE'] })?.ere_value
                    let name10 = findArray(num?.extensions, { ere_pos: ['10'], ere_code: ['JUDGE'] })?.ere_value
                    let name11 = findArray(num?.extensions, { ere_pos: ['11'], ere_code: ['JUDGE'] })?.ere_value

                    let j1 = findArray(num?.extensions, { ere_pos: ['1'], ere_code: ['SCORE_J'] })
                    let dis1 = findArray(num?.extensions, { ere_pos: ['1'], ere_code: ['DISCARDED'] })
                    let score1 = dis1.ere_value === 'Y' ? <del>{j1.ere_value}</del>
                        : j1.ere_value

                    let j2 = findArray(num?.extensions, { ere_pos: ['2'], ere_code: ['SCORE_J'] })
                    let dis2 = findArray(num?.extensions, { ere_pos: ['2'], ere_code: ['DISCARDED'] })
                    let score2 = dis2.ere_value === 'Y' ? <del>{j2.ere_value}</del>
                        : j2.ere_value

                    let j3 = findArray(num?.extensions, { ere_pos: ['3'], ere_code: ['SCORE_J'] })
                    let dis3 = findArray(num?.extensions, { ere_pos: ['3'], ere_code: ['DISCARDED'] })
                    let score3 = dis3.ere_value === 'Y' ? <del>{j3.ere_value}</del>
                        : j3.ere_value

                    let j4 = findArray(num?.extensions, { ere_pos: ['4'], ere_code: ['SCORE_J'] })
                    let dis4 = findArray(num?.extensions, { ere_pos: ['4'], ere_code: ['DISCARDED'] })
                    let score4 = dis4.ere_value === 'Y' ? <del>{j4.ere_value}</del>
                        : j4.ere_value

                    let j5 = findArray(num?.extensions, { ere_pos: ['5'], ere_code: ['SCORE_J'] })
                    let dis5 = findArray(num?.extensions, { ere_pos: ['5'], ere_code: ['DISCARDED'] })
                    let score5 = dis5.ere_value === 'Y' ? <del>{j5.ere_value}</del>
                        : j5.ere_value

                    let j6 = findArray(num?.extensions, { ere_pos: ['6'], ere_code: ['SCORE_J'] })
                    let dis6 = findArray(num?.extensions, { ere_pos: ['6'], ere_code: ['DISCARDED'] })
                    let score6 = dis6.ere_value === 'Y' ? <del>{j6.ere_value}</del>
                        : j6.ere_value

                    let j7 = findArray(num?.extensions, { ere_pos: ['7'], ere_code: ['SCORE_J'] })
                    let dis7 = findArray(num?.extensions, { ere_pos: ['7'], ere_code: ['DISCARDED'] })
                    let score7 = dis7.ere_value === 'Y' ? <del>{j7.ere_value}</del>
                        : j7.ere_value

                    let j8 = findArray(num?.extensions, { ere_pos: ['8'], ere_code: ['SCORE_J'] })
                    let dis8 = findArray(num?.extensions, { ere_pos: ['8'], ere_code: ['DISCARDED'] })
                    let score8 = dis8.ere_value === 'Y' ? <del>{j8.ere_value}</del>
                        : j8.ere_value

                    let j9 = findArray(num?.extensions, { ere_pos: ['9'], ere_code: ['SCORE_J'] })
                    let dis9 = findArray(num?.extensions, { ere_pos: ['9'], ere_code: ['DISCARDED'] })
                    let score9 = dis9.ere_value === 'Y' ? <del>{j9.ere_value}</del>
                        : j9.ere_value

                    let j10 = findArray(num?.extensions, { ere_pos: ['10'], ere_code: ['SCORE_J'] })
                    let dis10 = findArray(num?.extensions, { ere_pos: ['10'], ere_code: ['DISCARDED'] })
                    let score10 = dis10.ere_value === 'Y' ? <del>{j10.ere_value}</del>
                        : j10.ere_value

                    let j11 = findArray(num?.extensions, { ere_pos: ['11'], ere_code: ['SCORE_J'] })
                    let dis11 = findArray(num?.extensions, { ere_pos: ['11'], ere_code: ['DISCARDED'] })
                    let score11 = dis11.ere_value === 'Y' ? <del>{j11.ere_value}</del>
                        : j11.ere_value

                    return (
                        <>
                            <div className="d-flex justify-content-center">
                                <div className="w-25 p-1"><strong>{name1}</strong></div>
                                <div className="w-25 p-1"><strong>{name2}</strong></div>
                                <div className="w-25 p-1"><strong>{name3}</strong></div>
                                <div className="w-25 p-1"><strong>{name4}</strong></div>
                                <div className="w-25 p-1"><strong>{name5}</strong></div>
                                <div className="w-25 p-1"><strong>{name6}</strong></div>
                                {isIndividual ?
                                    <div className="w-25 p-1"><strong>{name7}</strong></div>
                                    : ''
                                }
                            </div>
                            <div className="d-flex justify-content-center">
                                <div className="w-25 p-0">{score1}</div>
                                <div className="w-25 p-0">{score2}</div>
                                <div className="w-25 p-0">{score3}</div>
                                <div className="w-25 p-0">{score4}</div>
                                <div className="w-25 p-0">{score5}</div>
                                <div className="w-25 p-0">{score6}</div>
                                {isIndividual ?
                                    <div className="w-25 p-0">{score7}</div>
                                    : ''
                                }
                            </div>
                            {unsafe.length > 0 ?
                                <div className="d-flex justify-content-center">
                                    <div className="w-100 p-1"><strong><Label data='HeaderUnsafeDive' /></strong></div>
                                </div>
                                : ''
                            }
                            {isSynchro ?
                                <><div className="d-flex justify-content-center">
                                    <div className="w-25 p-0"><strong>{name7}</strong></div>
                                    <div className="w-25 p-0"><strong>{name8}</strong></div>
                                    <div className="w-25 p-0"><strong>{name9}</strong></div>
                                    <div className="w-25 p-0"><strong>{name10}</strong></div>
                                    <div className="w-25 p-0"><strong>{name11}</strong></div>
                                </div>
                                    <div className="d-flex justify-content-center">
                                        <div className="w-25 p-0">{score7}</div>
                                        <div className="w-25 p-0">{score8}</div>
                                        <div className="w-25 p-0">{score9}</div>
                                        <div className="w-25 p-0">{score10}</div>
                                        <div className="w-25 p-0">{score11}</div>
                                    </div>
                                </>
                                : ''
                            }

                        </>
                    )
                }
            },

            {
                Header: <Label data='HeaderPen' />,
                id: 'PreviusPenalties',
                accessor: 'participant.code',
                className: 'text-end',
                headerClassName: 'text-end',

                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['DIVE'] })
                    return (num.er_pty)
                }

            },

            {
                Header: <Label data='HeaderDivePoints' />,
                id: 'PreviusDivePoints',
                accessor: 'participant.code',
                className: 'text-end',
                headerClassName: 'text-end',

                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['DIVE'] })
                    return (num.er_value)
                }

            },

            ColumnResult({ label: "HeaderTotalPoints" }),

            {
                Header: <Label data='HeaderOverallRank' />,
                id: 'PreviusOverallRank',
                accessor: 'participant.code',
                className: 'text-end',
                headerClassName: 'text-end',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['SCORE'] })
                    return (num.er_rank)
                }
            }

        ]
    )
}

export function getColumnsXS() {
    return (
        [
            ColumnNoc({}),
            ColumnName({}),
            {
                Header: <Label data='HeaderDivePoints' />,
                id: 'PreviusName',
                accessor: 'participant.code',
                className: 'text-end',
                headerClassName: 'text-end',

                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['DIVE'] })
                    return (num.er_value)
                }

            },

            ColumnResult({ label: "HeaderTotalPoints" }),

            {
                Header: <Label data='HeaderOverallRank' />,
                id: 'PreviusResult',
                accessor: 'participant.code',
                className: 'text-end',
                headerClassName: 'text-end',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let num = findArray(row?.extendedResults, { er_pos: [row.currentSplit], er_code: ['SCORE'] })
                    return (num.er_rank)
                }
            }
        ]
    )
}

const PreviousCompetitor = ({ data }) => {

    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    let columns
    if (breakPoint === "xxl" || breakPoint === "xl" || breakPoint === "lg") {
        columns = getColumns(data.currentSplit, mirs_rsc)
    } else {
        columns = getColumnsXS()
    }
    const configPrevious = useMemo(() => columns, [data.currentSplit, breakPoint]);

    return (
        <div className="mirs-page-container-previous">
            < MirsTable
                className='table-result'
                data={[data]}
                columns={configPrevious}
                keyRow='participant-code'
                caption={<Label data='HeaderPreviousTeam' />}
                id={`mirs-table-result2-${mirs_rsc}`}
            />
        </div>
    );
}

export default PreviousCompetitor;